webpackJsonp([35783957827783],{

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/homepage-video.485dbd9a.mp4";

/***/ }),

/***/ 474:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTIgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUxLjMgKDU3NTQ0KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5jaGV2cm9ucy1kb3duPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlJlbWFzdGVyZCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4KICAgICAgICA8ZyBpZD0iSG9tZXBhZ2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC05NTQuMDAwMDAwLCAtMTAwNy4wMDAwMDApIiBzdHJva2U9IiNGRkZGRkYiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxnIGlkPSJIZXJvIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJjaGV2cm9ucy1kb3duIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5NTUuMDAwMDAwLCAxMDA4LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwb2x5bGluZSBpZD0iU2hhcGUiIHBvaW50cz0iMCA3IDUgMTIgMTAgNyI+PC9wb2x5bGluZT4KICAgICAgICAgICAgICAgICAgICA8cG9seWxpbmUgaWQ9IlNoYXBlIiBwb2ludHM9IjAgMCA1IDUgMTAgMCI+PC9wb2x5bGluZT4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logos-clients.ec329b30.png";

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.queryHomepage = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sections = __webpack_require__(25);
	
	var _helpers = __webpack_require__(41);
	
	var _components = __webpack_require__(78);
	
	var _logosClients = __webpack_require__(477);
	
	var _logosClients2 = _interopRequireDefault(_logosClients);
	
	var _iconWhiteChevsDown = __webpack_require__(474);
	
	var _iconWhiteChevsDown2 = _interopRequireDefault(_iconWhiteChevsDown);
	
	var _Button = __webpack_require__(77);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _iconWhiteCalendar = __webpack_require__(131);
	
	var _iconWhiteCalendar2 = _interopRequireDefault(_iconWhiteCalendar);
	
	var _homepageVideo = __webpack_require__(465);
	
	var _homepageVideo2 = _interopRequireDefault(_homepageVideo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Homepage = function (_Component) {
	  _inherits(Homepage, _Component);
	
	  function Homepage(props) {
	    _classCallCheck(this, Homepage);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      scrollDiv: 'homepage-main'
	    };
	    _this.onButtonClick = _this.onButtonClick.bind(_this);
	    return _this;
	  }
	
	  Homepage.prototype.onButtonClick = function onButtonClick() {
	    (0, _helpers.scrollToDiv)(this.state.scrollDiv);
	  };
	
	  Homepage.prototype.render = function render() {
	    var scrollDiv = this.state.scrollDiv;
	    var data = this.props.data;
	
	    var wp = (0, _helpers.getPageData)(data, 'Home');
	    return _react2.default.createElement(
	      _sections.PageWrapper,
	      { page: 'front-page' },
	      _react2.default.createElement(
	        'section',
	        { className: 'hero hero--home' },
	        _react2.default.createElement(
	          'div',
	          { className: 'hero__text-wrapper hero__text-wrapper--home' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title title--white title--lg' },
	            'Looking to see clearer skies?'
	          ),
	          _react2.default.createElement(
	            'h1',
	            { className: 'title title--white title--mid' },
	            'Commercial & residential window cleaning services.'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'text text--white text--lg' },
	            'Improving the view across Basingstoke & surrounding areas.'
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'button', onClick: this.onButtonClick },
	            'Learn More'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'hero__image-wrapper' },
	          _react2.default.createElement('img', {
	            className: 'hero__image',
	            src: (0, _helpers.getImageSrc)(wp.hero_background),
	            alt: 'Window Cleaning'
	          })
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'hero__chev-wrapper', onClick: this.onButtonClick },
	          _react2.default.createElement('img', { src: _iconWhiteChevsDown2.default, alt: 'Chevrons Down' })
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'home-main', id: scrollDiv },
	        _react2.default.createElement(
	          'div',
	          { className: 'home-main__text-top' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title' },
	            'Reliable, safe and trustworthy'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'text text--lg' },
	            'Offering professional window and gutter cleaning services since 2009, we\u2019re passionate about professionalism, reliability and our standard of work. No job or project is too small or too big.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'home-services' },
	          _react2.default.createElement(
	            'div',
	            { className: 'home-services__row home-services__row--top' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'home-services__list home-services__list--top' },
	              _react2.default.createElement(_components.ServiceItem, {
	                title: 'Pressure Washing',
	                text: 'Clear H2o offer a pressure washing services ranging from driveways, paved areas, curb stones, rendering, roofs, car parks and more.',
	                url: '/services/#services-intro'
	              }),
	              _react2.default.createElement(_components.ServiceItem, {
	                title: 'Commercial/Domestic Window Cleaning',
	                text: 'We can clean it all from just the windows to all the Upvc framework roofs internally and externally just let us know your requirements.',
	                url: '/services/#services-intro'
	              }),
	              _react2.default.createElement(_components.ServiceItem, {
	                title: 'Gutter Clearing',
	                text: 'If you are buying or selling your property or just want to keep up with the exterior (outlook) maintenance all year round.',
	                url: '/services/#services-intro'
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'home-services__image-wrapper home-services__image-wrapper--top' },
	              _react2.default.createElement('img', {
	                className: 'home-services__image',
	                src: (0, _helpers.getImageSrc)(wp.row_image_top),
	                alt: 'Service Outline'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'home-services__row home-services__row--bottom' },
	            _react2.default.createElement(
	              'div',
	              { className: 'home-services__image-wrapper' },
	              _react2.default.createElement('img', {
	                className: 'home-services__image',
	                src: (0, _helpers.getImageSrc)(wp.row_image_bottom),
	                alt: 'Service Outline'
	              })
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'home-services__list home-services__list--right' },
	              _react2.default.createElement(_components.ServiceItem, {
	                title: 'Cladding & Solar Panel Cleaning',
	                text: 'Regular cleaning of your building/house should be part of a maintenance program that helps to protect your investment.',
	                url: '/services/#maintaining-quality'
	              }),
	              _react2.default.createElement(_components.ServiceItem, {
	                title: 'Conservatory Cleaning',
	                text: 'We offer a complete conservatory cleaning service to restore and clean your conservatory to an as-new condition.',
	                url: '/services/#maintaining-quality'
	              })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'home-clients' },
	        _react2.default.createElement(
	          'div',
	          { className: 'home-video-wrapper' },
	          _react2.default.createElement(
	            'video',
	            { className: 'video-container video-container-overlay', controls: true },
	            _react2.default.createElement('source', { src: _homepageVideo2.default, type: 'video/mp4' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'home-clients__text-top' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title title--white' },
	            'Trusted by organisations across Hampshire'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'text text--white' },
	            'Working with schools, offices, blocks of apartments, hospitals and more, we\u2019re proud to have a large number of clients within 100 mile radius of Basingstoke who continue to grow year by year.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'home-clients__logos-wrapper' },
	          _react2.default.createElement('img', {
	            className: 'home-clients__logos',
	            src: _logosClients2.default,
	            alt: 'Our Clients'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'cta' },
	        _react2.default.createElement(
	          'div',
	          { className: 'cta__column-left' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'title title--cta' },
	            'Interested in our services?'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'text' },
	            'Speak to us today to discuss how our services can benefit you.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cta__column-right' },
	          _react2.default.createElement(_Button2.default, { text: 'Learn more', to: '/about', outline: true }),
	          _react2.default.createElement(
	            'a',
	            {
	              className: 'button booking-button',
	              href: 'https://book-clear-h2o.web.app/',
	              target: '_blank'
	            },
	            _react2.default.createElement('img', { src: _iconWhiteCalendar2.default, alt: '' }),
	            'Create Booking'
	          )
	        )
	      )
	    );
	  };
	
	  return Homepage;
	}(_react.Component);
	
	exports.default = Homepage;
	var queryHomepage = exports.queryHomepage = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-d7a409d53dc03f5e5617.js